import { formatDate } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'openEnd',
  standalone: true,
})
export class OpenEndPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  public transform(value: string): string {
    if (!value) {
      return null;
    }

    return value === '9999-12-31' ? '<span class="highlighted">open-end</span>' : formatDate(value, 'dd.MM.yyyy', this.locale);
  }
}
